import { gql } from '@apollo/client';

export const ITEMS_LIST_QUERY = gql`
  query items($pager: PagerInputNew, $filters: ItemsFilterInput) {
    items(pager: $pager, filters: $filters) {
      total
      values {
        id
        code
        name
        typeId
        typeCode
        typeName
        enabled
      }
    }
  }
`;

export const ITEM_TYPES_QUERY = gql`
  query itemTypes {
    itemTypes {
      id
      code
      name
    }
  }
`;
